import PropTypes from 'prop-types';

import { classList } from '../../utils';
import styles from '../SmartLink/styles.scss';

EmailLink.propTypes = {
  email: PropTypes.string.isRequired,
  inheritColor: PropTypes.bool,
  className: PropTypes.string,
  // ...props
};

export default function EmailLink({
  email,
  inheritColor = false,
  className = '',
}) {
  return (
    <a
      href={`mailto:${email}`}
      className={classList({
        [styles.root]: true,
        [styles.inheritColor]: inheritColor,
        [className]: true,
      })}
    >
      {email}
    </a>
  );
}
